import React, { useEffect, useState } from 'react';
import noImage from '../assets/no-image.svg';

const ProductImage = ({ src, alt, loading = 'lazy', decoding = 'async', ...props }: React.ImgHTMLAttributes<HTMLImageElement>) => {
    const [failed, setFailed] = useState(false);
    useEffect(() => setFailed(false), [src]);
    return <img {...props} loading={loading} decoding={decoding} src={!src || failed ? noImage : src} alt={alt}
        onError={() => setFailed(true)} />;
};

export default ProductImage;
